var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('text',{staticClass:"skyword",attrs:{"id":"currentWord","y":_vm.y,"x":_vm.x,"text-anchor":"middle","dominant-baseline":"middle","font-family":"sans-serif","font-size":"60","fill":"#000000"}},[_vm._v(_vm._s(this.$parent.currentWord))])])
}
var staticRenderFns = []

export { render, staticRenderFns }